import { PdfInvoiceType } from '../enums/pdf-invoice-type.enum';

export class PdfInvoiceTypeHelper {
  public static buildPdfMergeNotificationCardMessage(length: number, pdfDocumentType: PdfInvoiceType): string | undefined {
    let msg: { msgPlural: string | undefined; msgSingular: string | undefined } = { msgPlural: undefined, msgSingular: undefined };

    if (pdfDocumentType === PdfInvoiceType.Invoice || pdfDocumentType === PdfInvoiceType.InvoiceWithParams) {
      msg = {
        msgPlural: `PDF de ${length} factures`,
        msgSingular: `PDF de ${length} facture`,
      };
    } else if (pdfDocumentType === PdfInvoiceType.InvoiceDeliveryFormStatement) {
      msg = {
        msgPlural: `PDF de ${length} relevés de bons`,
        msgSingular: `PDF de ${length} relevé de bons`,
      };
    } else if (pdfDocumentType === PdfInvoiceType.InvoiceAndInvoiceDeliveryFormStatement) {
      msg = {
        msgPlural: `PDF de ${length} factures définitives avec relevés de bons`,
        msgSingular: `PDF de ${length} facture définitive avec relevé de bons`,
      };
    }

    const message = length > 1 ? msg.msgPlural : msg.msgSingular;
    return message;
  }

  public static buildPdfMergeNotifyMessage(length: number, pdfDocumentType: PdfInvoiceType): string | undefined {
    let msg: { msgPlural: string | undefined; msgSingular: string | undefined } = { msgPlural: undefined, msgSingular: undefined };

    if (pdfDocumentType === PdfInvoiceType.Invoice || pdfDocumentType === PdfInvoiceType.InvoiceWithParams) {
      msg = {
        msgPlural: `PDF multiple de ${length} factures en cours de génération`,
        msgSingular: `PDF multiple de ${length} facture en cours de génération`,
      };
    } else if (pdfDocumentType === PdfInvoiceType.InvoiceDeliveryFormStatement) {
      msg = {
        msgPlural: `PDF multiple de ${length} relevés de bons en cours de génération`,
        msgSingular: `PDF multiple de ${length} relevé de bons en cours de génération`,
      };
    } else if (pdfDocumentType === PdfInvoiceType.InvoiceAndInvoiceDeliveryFormStatement) {
      msg = {
        msgPlural: `PDF multiple de ${length} factures définitives avec relevés de bons en cours de génération`,
        msgSingular: `PDF multiple de ${length} facture définitive avec relevé de bons en cours de génération`,
      };
    }

    const message = length > 1 ? msg.msgPlural : msg.msgSingular;
    return message;
  }

  public static translateEnum(enumValue: PdfInvoiceType, pluralFlag = false): string | undefined {
    if (enumValue === PdfInvoiceType.Invoice || enumValue === PdfInvoiceType.InvoiceWithParams) {
      return pluralFlag ? 'Factures définitives' : 'Facture définitive';
    } else if (enumValue === PdfInvoiceType.InvoiceAndInvoiceDeliveryFormStatement) {
      return pluralFlag ? 'Factures définitives avec relevé de bons' : 'Facture définitive avec relevé de bons';
    } else if (enumValue === PdfInvoiceType.InvoiceDeliveryFormStatement) {
      return pluralFlag ? 'Relevés de bons' : 'Relevé de bons';
    }
    return undefined;
  }
}
